import { ProductModel } from './../models/product.model';
import {Component, Input, OnChanges} from '@angular/core';
import {ModelModel} from '../models/model.model';


@Component({
  selector: 'app-product-details-related-products',
  template: `
    <app-carousel [model]="this.model.relatedProducts" [productLine]="this.productLine" (selected)="this.selected($event)"></app-carousel>
  `,
  styles: [
    `
    app-carousel {
      width: 100%;
    }
    
    .viewMoreButton {
      border: 1px solid #A50034;	
      border-radius: 4px;	
      background-color: #FFFFFF;
      color: #A50034;	
      font-family: 'LGEIRegular';
      font-size: 16px;	
      line-height: 2;	
      text-align: center;
      width: 150px;
      cursor: pointer;
    }

    .flex-row {
      display: flex;
      flex-wrap: wrap;
      padding-left: 15px;
      padding-right: 15px;
    }
    .flex-row > [class*='col-'] {
      display: flex;
      flex-direction: column;
    }
    
    .flex-row .thumbnail,
    .flex-row .caption {
      flex-direction: column;
      display: flex;
      flex: 1 0 auto;
      height: auto;
      position: relative;
    }
    .flex-text {
      flex-grow: 1;
    }
    .flex-row img {
      min-width: 0;
      width: 100%;
    }

    @media only screen and (max-width : 480px){
      .flex-row > [class*='col-'] {
          width: 100%;
      }
      .flex-row  {
        padding-left: 0px;
        padding-right: 0px;
      }

    }

    @media only screen and (max-width : 768px){
      .height-responsive {
          height: 450px;
      }
    }

    @media only screen and (min-width: 769px) {}
    .col-xl-2 {
        -ms-flex: 0 0 20%;
        flex: 0 0 20%;
        max-width: 20%;
    }
  `
  ]
})
export class ProductDetailsRelatedProductsComponent implements OnChanges {
  @Input() model: ProductModel;
  @Input() productLine: string;
  @Input() iscommercial: string;
  @Input() productClass: string = null;
  relatedProducts: ProductModel[] = [];
  viewMoreToggle: Boolean = true;
  viewMoreText = 'View More';
  showViewMore = false;

  ngOnChanges() {
    let numDisplayed = 0;
    for(let i=0;i<this.model.relatedProducts.length && numDisplayed < 5;i++) {
        const rp = this.model.relatedProducts[i];
        // Only display if No Line or class is selected or related is part of that line or class
        if ( rp.shouldDisplay(this.iscommercial, this.productClass)) {
          this.relatedProducts.push(rp);
          numDisplayed++;
        }
      }
      this.showViewMore = numDisplayed > 4;
    }

  viewMore() {
    this.relatedProducts = [];
    if (this.viewMoreToggle === true) {
      for(let i=0;i<this.model.relatedProducts.length;i++) {
        if(this.model.relatedProducts[i].shouldDisplay(this.iscommercial, this.productClass)) {
          this.relatedProducts.push(this.model.relatedProducts[i]);
        }
      }
      this.viewMoreToggle = false;
      this.viewMoreText = 'View Less';
    } else {
      let numDisplayed = 0;
      for(let i=0;i<this.model.relatedProducts.length && numDisplayed < 5;i++) {
        if (i < 5) {
          if( this.model.relatedProducts[i].shouldDisplay(this.iscommercial, this.productClass)) {
            this.relatedProducts.push(this.model.relatedProducts[i]);
            numDisplayed++;
          }
        }
      }
      this.viewMoreToggle = true;
      this.viewMoreText = 'View More';
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/product-category/components/product-details-related-products.component.ts